import Vue from 'vue'
import VueRouter from 'vue-router';
import pipeline from "./pipeline";
import store from "@/store/store";
import cookie from "../store/modules/cookies"

import Auth from "./routes/authRoutes";
import Account from "./routes/accountRoutes";
import Public from "./routes/publicRoutes"
//import axios from "../store/modules/axios"

Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...Auth,
    ...Account,
    ...Public
  ]
})


//function login

router.beforeEach((to, from, next) => {
  
  //checking for a valid token
  //check in the cookie and then check in the local storage
  
  let localToken = localStorage.getItem("access_token")
  //console.log("Local Token", localToken)
  let cookieToken = cookie.get("token")
  //console.log("Cookie Token", cookieToken)

  if (localToken == null) {
    //check if there is cookie token
    //console.log("There is no local token")
    if (cookieToken) {
      //console.log("there is a cookie token, log user in with token")
      store.dispatch("userauth/aTokenLogin", cookieToken)
    } 
  } else if (localToken != null) {
    ////console.log("there is a local token")
    //check if the there is a cookie token
    if (cookieToken && cookieToken == localToken) {
      console.log("cookie token is equal to local token, leave things as they are")
    } else if (cookieToken && cookieToken != localToken) {
      //console.log("the tokens are different, default to cookie token and login user")
      store.dispatch("userauth/aTokenLogin", cookieToken)
    } else {
      //console.log("set the local token to the cookie token")
      cookie.set("token", localToken, "1d", null, "mi-sos.org", null, "Secure")
    }
  }
  
  /* if (cookie.get("token")) {
    console.log("token is found", cookie.get("token"));
    cookieToken = cookie.get("token");
    if (cookieToken != localToken) {
      console.log("something needs to be done")
    }
  } */



  console.log("Then move to other things")

  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: pipeline(context, middleware, 1)
  })

})

export default router;
